import { FC } from "react";
import { Link } from "react-router-dom";

import ProjectsList from "../../../pages/projects/projectsList/projectsList"

import SectionContent from "../../../components/sectionContent/sectionContent";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";

const ProjectsListSection: FC = () => {
    return (
        <div className="App">
            <Sidebar />
            <SectionContent
                section="Проекты"
                pageName="projects"
                title="Список проектов"
            >
                <div className="content__main">
                    <div className="btns">
                        <Link to="/projects" className="tab">
                            <div className="buttons__btn --active">Мерчендайзинг</div>
                        </Link>
                    </div>
                    <ProjectsList />
                </div>
            </SectionContent>
        </div>
    );
};

export default ProjectsListSection;